import { render, staticRenderFns } from "./IaList.vue?vue&type=template&id=4b9cfd45&scoped=true&"
import script from "./IaList.vue?vue&type=script&lang=js&"
export * from "./IaList.vue?vue&type=script&lang=js&"
import style0 from "./IaList.vue?vue&type=style&index=0&id=4b9cfd45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cfd45",
  null
  
)

export default component.exports